import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { store } from './app/store';

import { setupAPIInstanceInterceptor } from '@/api/authorizedAPI';
// import '@yara-dpp/frontend-components.styles.tailwind-styles/styles.css';
import '@yaradigitallabs/ahua-react/fonts/noto-sans/font-face.css';
import '@yaradigitallabs/ahua-react/fonts/yara-max/font-face.css';
// import { AhuaProvider } from '@yaradigitallabs/ahua-react';
setupAPIInstanceInterceptor();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* <AhuaProvider> */}
  <Provider store={store}>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </Provider>
  {/* </AhuaProvider> */}
  </StrictMode>
);

